import { render, staticRenderFns } from "./bizcompTitle.vue?vue&type=template&id=6783c874"
import script from "./bizcompTitle.vue?vue&type=script&lang=js"
export * from "./bizcompTitle.vue?vue&type=script&lang=js"
import style0 from "./bizcompTitle.vue?vue&type=style&index=0&id=6783c874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports